import { createRoot } from 'react-dom/client'
import { cloneElement } from 'react'

interface MarkerType {
  component: any
  location: google.maps.LatLng
  map: google.maps.Map
  parentNode: any
  panes?: any
}

const Marker: google.maps.OverlayView & {
  new (params: {
    location: google.maps.LatLng
    map: google.maps.Map
    component: any
    index?: number
    isCenter?: boolean
  }): MarkerType & google.maps.OverlayView
} = function(
  this: MarkerType & google.maps.OverlayView & { isCenter?: boolean },
  params: any,
): void {
  this.setMap(params.map)

  this.draw = function() {
    const { location, map, component, index, isCenter } = params

    const _location = new google.maps.LatLng(
      location.location.coordinates[1],
      location.location.coordinates[0],
    )

    // Position the overlay
    const projection = this.getProjection()
    const point = projection.fromLatLngToDivPixel(_location)

    if (point) {
      this.parentNode.style.left = point.x + 'px'
      this.parentNode.style.top = point.y + 'px'
    }

    this.isCenter = params.isCenter

    const root = createRoot(this.parentNode)

    root.render(
      cloneElement(component, {
        parentNode: this.parentNode,
        index,
        children: location.children,
        isCenter,
      }),
    )
  }

  this.onAdd = function() {
    const { location, map, component } = params

    this.parentNode = document.createElement('div')

    this.parentNode.style.position = 'absolute'
    this.parentNode.addEventListener('click', () => {
      location?.onClick?.()
    })

    const panes: any = this.getPanes()
    if (this.parentNode && panes) {
      panes.overlayImage.appendChild(this.parentNode)
    }
  }

  this.onRemove = function() {
    if (this.parentNode && this.parentNode.parentNode) {
      this.parentNode.parentNode.removeChild(this.parentNode)
    }
  }
} as any

export default Marker
